import React from 'react';

import { ButtonSC, SuffixSC, PrefixSC } from './button.styled';

import svgLoadingSpinner from '@common/assets/svg/icon-loading_spinner.svg';

import { TButtonProps } from './types';

const Button: React.FC<TButtonProps> = ({
  size = 'medium',
  variation = 'primary',
  shape = 'rectangular',
  isLoading = false,
  isBlock = false,
  suffix = null,
  prefix = null,
  children,
  ...rest
}) => {
  return (
    <ButtonSC {...{ size, shape, variation, isBlock }} {...rest}>
      {prefix && <PrefixSC>{prefix}</PrefixSC>}
      {isLoading ? <img src={svgLoadingSpinner} alt="loading-spinner" /> : null}
      {children}
      {suffix && <SuffixSC>{suffix}</SuffixSC>}
    </ButtonSC>
  );
};

export type TPropsSC = TButtonProps;

export default Button;
